module.exports = __webpack_public_path__ + "img/stage-glow-ne.233aff5a.png";